export const FETCH_STYLIST_CARD_DATA_FOR_STYLIST_FLOW_REQUEST = "FETCH_STYLIST_CARD_DATA_FOR_STYLIST_FLOW_REQUEST";
export const FETCH_STYLIST_CARD_DATA_FOR_STYLIST_FLOW_SUCCESS = "FETCH_STYLIST_CARD_DATA_FOR_STYLIST_FLOW_SUCCESS";
export const FETCH_STYLIST_CARD_DATA_FOR_STYLIST_FLOW_FAILURE = "FETCH_STYLIST_CARD_DATA_FOR_STYLIST_FLOW_FAILURE";

export const SET_CURRENT_STYLIST = "SET_CURRENT_STYLIST";
export const RESET_DATA_SWITCH_FLOW = "RESET_DATA_SWITCH_FLOW";
